import _ from 'underscore';

export const ResponsiveAd = {
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Responsive Ad',
    },
    LandscapeImageMediaId: {
      'bulk-upload-header': 'Landscape Image Media Id',
    },
    SquareImageMediaId: {
      'bulk-upload-header': 'Square Image Media Id',
    },
    LandscapeLogoMediaId: {
      'bulk-upload-header': 'Landscape Logo Media Id',
    },
    SquareLogoMediaId: {
      'bulk-upload-header': 'Square Logo Media Id',
    },
    Headlines: {
      'bulk-upload-header': 'Headlines',
      'bulk-upload-mapper': function (value) {
        return value;
      },
    },
    LongHeadlines: {
      'bulk-upload-header': 'Long Headlines',
      'bulk-upload-mapper': function (value) {
        return value;
      },
    },
    Descriptions: {
      'bulk-upload-header': 'Descriptions',
      'bulk-upload-mapper': function (value) {
        return value;
      },
    },
    LongHeadline: {
      'bulk-upload-header': 'Long Headline',
    },
    BusinessName: {
      'bulk-upload-header': 'Business Name',
    },
    CallToAction: {
      'bulk-upload-header': 'Call To Action',
    },
    CallToActionLanguage: {
      'bulk-upload-header': 'Call To Action Language',
    },
    CallToActionText: {
      'bulk-upload-header': 'Call To Action Text',
      maxLength: 15,
    },
    FinalUrls: {
      'bulk-upload-header': 'Final Url',
      'bulk-upload-mapper': function (value) {
        return value.join('; ');
      },
    },
    MobileFinalUrls: {
      'bulk-upload-header': 'Mobile Final Url',
      'bulk-upload-mapper': function (value) {
        // For ResponsiveAd, mt expects deleted_value string when updating this with empty
        if (_.isArray(value)) {
          return value.join('; ');
        }

        return value;
      },
    },
    ImpressionTrackingUrls: {
      'bulk-upload-header': 'Impression Tracking Urls',
      'bulk-upload-mapper': function (value) {
        if (_.isArray(value)) {
          return value.join('; ');
        }

        return value;
      },
    },
    TrackingUrlTemplate: {
      'bulk-upload-header': 'Tracking Template',
    },
    FinalUrlSuffix: {
      'bulk-upload-header': 'Final Url Suffix',
    },
    UrlCustomParameters: {
      'bulk-upload-header': 'Custom Parameter',
      'bulk-upload-mapper': function (value) {
        // Whenever the ad is updated with empty value, we need to
        // set it to 'delete_value' in order to overwrite the existing value of the parameter
        if (value === 'delete_value') {
          return value;
        }
        return _.map(value, p => `{_${p.Key}}=${p.Value}`).join('; ');
      },
    },
    DevicePreference: {
      'bulk-upload-header': 'Device Preference',
    },
    Images: {
      type: 'string',
    },
    HotSpots: {
      type: 'string',
    },
    BoostAnchors: {
      type: 'string',
      'bulk-upload-header': 'Boost Anchors',
    },
    Videos: {
      type: 'string',
    },
    CampaignName: {
      'bulk-upload-header': 'Campaign',
    },
    AdGroupName: {
      'bulk-upload-header': 'Ad Group',
    },
    VerifiedTrackingData: {
      'bulk-upload-header': 'Verified Tracking Settings',
      'bulk-upload-mapper': function (value) {
        if (_.isEmpty(value) || (_.isString(value) && value.length === 0)) {
          // '': two inouts are empty
          // 'error': Only one of id is '', invalid
          return 'delete_value';
        }
        return value;
      },
    },
  },
};
